import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signInReq, signUpReq, verifyReq, resendCodeReq } from '../auth';
import { toast } from 'react-toastify';
import Notification from '../../components/Notification';
import { useNavigate } from 'react-router-dom';

export const useSignInMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['signin'],
        mutationFn: async (data) => {
            const response = await signInReq({ ...data });
            if (response.data.access) {
                localStorage.setItem('assessmentai-token', response.data.access);
            }
            return response.data;
        },
        onSuccess: async () => {
            queryClient.invalidateQueries(['user-info']);
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};
export const useSignUpMutation = () => {
    const navigate = useNavigate();

    return useMutation({
        mutationKey: ['signup'],
        mutationFn: async (data) => {
            const response = await signUpReq({ ...data });
            return response.data;
        },
        onSuccess: async (data, variables) => {
            navigate(`/verify?email=${encodeURIComponent(variables?.email)}`);
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};
export const useVerifyMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['verify'],
        mutationFn: async (data) => {
            const response = await verifyReq({ ...data });
            if (response.data.access) {
                localStorage.setItem('assessmentai-token', response.data.access);
            }
            return response.data;
        },
        onSuccess: async () => {
            queryClient.invalidateQueries(['user-info']);
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};
export const useResendCodeMutation = () => {
    return useMutation({
        mutationKey: ['resend-code'],
        mutationFn: async (data) => {
            const response = await resendCodeReq({ ...data });
            return response.data;
        },
        onSuccess: async (data) => {
            toast.success(<Notification text={data?.message} />);
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};